import WordPressLogo from 'almanac-ui/icons/24/WordPressLogo'
import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { useModals } from 'almanac-ui/Modal'
import { WordPressIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

import { CardButtons } from './CardButtons'
import WordPressInitialization from 'components/IntegrationInitialization/WordPressInitialization/WordPressInitialization'
import { useBlogIntegrations } from 'hooks/useBlogIntegrations'

interface WordPressCardProps {
  integrations?: WordPressIntegration[]
  canConnect?: boolean
}

export const WordPressCard = ({ integrations = [], canConnect }: WordPressCardProps) => {
  const { openModal } = useModals()
  const { getRestrictionMessage } = useBlogIntegrations()

  const canConnectWordPress = canConnect ?? true
  const restrictionMessage = getRestrictionMessage(ExternalIntegrationEnum.WordPress)

  const cardContent = (
    <ExternalIntegrationCard
      title={'WordPress'}
      description={'Publish your blog posts and pages directly from Blaze'}
      integrations={integrations}
      icon={<WordPressLogo size={20} />}
      isDisabled={!canConnectWordPress}
      buttons={
        <CardButtons
          onConnect={() => openModal(WordPressInitialization)}
          provider={ExternalIntegrationEnum.WordPress}
          isConnected={integrations.length > 0}
          integration={integrations[0]}
          isDisabled={!canConnectWordPress}
          tooltipMessage={restrictionMessage || undefined}
        />
      }
    />
  )

  return cardContent
}
